function NewQuotaDef() {
    return {
        id: null,       
        name: "New Quota",
		IsAnd: false,
		endDate: null,		
		quotas: [],
		parameters: [],
      }
}
export default NewQuotaDef;